import { useMemo } from 'react';
import {
  useIsAuthorizedUserContourA,
  useIsAuthorizedUserContourB,
  useIsUnautorizedUser
} from 'store/features/auth';

import { isIOS, isSafariBrowser } from 'common/utils/checkBrowserType';

import {
  IS_DIFFERENT_CONTOURS,
  IS_PARENT_WINDOW_CONTOUR_A,
  IS_ACTIVE_CONTOUR_A,
  IS_ACTIVE_CONTOUR_B
} from '../constants';

export const useIsAllowDependsOnContour = () => {
  const isAuthorizedUserContourA = useIsAuthorizedUserContourA();
  const isAuthorizedUserContourB = useIsAuthorizedUserContourB();
  const isUnauthorizedUser = useIsUnautorizedUser();

  const result = useMemo(() => (
    ((IS_DIFFERENT_CONTOURS && ((IS_ACTIVE_CONTOUR_A && (isAuthorizedUserContourA || isUnauthorizedUser)) || (IS_ACTIVE_CONTOUR_B && isAuthorizedUserContourB && !IS_PARENT_WINDOW_CONTOUR_A))) || !IS_DIFFERENT_CONTOURS || isIOS || isSafariBrowser)
  ), [
    isAuthorizedUserContourA,
    isAuthorizedUserContourB,
    isUnauthorizedUser
  ]);

  return result;
};
